import {Box, Stack} from "@mui/material";
import ContactCard from "./components/ContactCard";
import SocialMediaButtons from "./components/SocialMediaButtons";
import FooterData from "./components/FooterData";
import InnField from "./components/InnField";
import MainLogo from "components/MainLogo";

const MobileFooter = () => {
  return (
    <Stack spacing={2.5}>
      <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
        <MainLogo iconProps={{sx: {color: 'primary.main', p: {xxs: 1}, width: {xxs: 40}, height: {xxs: 68}}}}/>
        <SocialMediaButtons/>
      </Stack>
      <ContactCard/>
      <Box sx={{display: {xxs: 'block', md: 'flex'}, flexWrap: {md: 'wrap'}}}>
        <InnField/>
        <FooterData/>
      </Box>
    </Stack>
  )
}

export default MobileFooter
